/**
 * IOSFilePreviewArea 组件
 * 显示已选文件列表，管理文件预览和状态
 * 采用iOS风格设计，支持水平滚动
 */
import React from 'react';
import { IOSFilePreviewItem } from './IOSFilePreviewItem';
import { useAtomValue } from 'jotai';
import { fileIdsSelector } from '../../../../atoms/v3/uppyAtoms';
import { motion } from 'framer-motion';
import './IOSFilePreview.css';

interface IOSFilePreviewAreaProps {
  className?: string;
}

export const IOSFilePreviewAreaComponent: React.FC<IOSFilePreviewAreaProps> = ({ className = '' }) => {
  // 使用优化的选择器，只在文件列表结构变化时更新
  const fileIds = useAtomValue(fileIdsSelector);

  if (fileIds.length === 0) return null;

  return (
    <motion.div
      className={`py-2 ${className}`}
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: 'auto' }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="overflow-x-auto scrollbar-hide">
        <div className="flex flex-nowrap px-2 pb-1">
          {fileIds.map(fileId => (
            <IOSFilePreviewItem key={fileId} fileId={fileId} />
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export const IOSFilePreviewArea = React.memo(IOSFilePreviewAreaComponent);

export default IOSFilePreviewArea;
